module.exports = __webpack_public_path__ + "static/media/19ESCAP51.05ad9cb3.jpg";